import { Typography, Grid, TextField, FormLabel, FormControlLabel, Checkbox, Alert } from "@deere/fuel-react";
import { QUESTION_TYPES, TOOLTIP_PLACEHOLDER, TOOLTIP_LABEL, HELP_TEXT, SELF_SERVICE_MATRIX_INFO_MSG } from "../../../../utils/surveyLiterals";

const DetailsTab = ({ changeHandler, que , isPartSection}) => {
  return (
    <Grid container mt={4} spacing={4}>
      <Grid item xs={2}>
        <FormLabel sx={{ width: "100%" }}>Type</FormLabel>
        <Typography variant="p" size="sm">
          {que.typeText}
        </Typography>
      </Grid>
      <Grid item xs={que.type === QUESTION_TYPES.VIEWER ? 10 : 6}>
        <TextField label="Label" required placeholder="Please enter the question label here..." name="label" onChange={(e) => changeHandler(e, que.code)} value={que.text} />
      </Grid>

      {que.type !== QUESTION_TYPES.VIEWER && (
        <>
          <Grid item xs={2}>
            <TextField
              label="Group ID"
              placeholder="Group ID"
              type="number"
              name="questionsGroup"
              onChange={(e) => {
                if (e.target.value && e.target.value < 1) e.target.value = 1;
                changeHandler(e, que.code);
              }}
              value={que.questionsGroup}
            />
          </Grid>
          {que.type !== QUESTION_TYPES.LABEL && (
            <Grid item xs={2} mt={6}>
              <FormControlLabel control={<Checkbox name="required" checked={que.required} />} label="Is required" onChange={(e) => changeHandler(e, que.code)} />
            </Grid>
          )}
        </>
      )}
        <Grid item xs={que.type === QUESTION_TYPES.VIEWER ? 10 : 6}>
        <TextField label={HELP_TEXT}  placeholder={TOOLTIP_PLACEHOLDER} name={TOOLTIP_LABEL} onChange={(e) => changeHandler(e, que.code)} value={que.helpText} multiline minRows={2} />
      </Grid>
      {que.type === QUESTION_TYPES.MATRIX && (
        <Grid item xs={12}>
          <Alert variant="info" sx={{ width: "100%", padding: "6px 8px", "& .MuiTypography-body1": { fontSize: "12px" }, "& .MuiTypography-body2": { fontSize: "12px" } }}>
            {SELF_SERVICE_MATRIX_INFO_MSG}
          </Alert>
        </Grid>
      )}
    </Grid>
  );
};

export default DetailsTab;
